import React from 'react'
import Navbar from '../navbar/Navbar'
import Sidebar from '../sidebar/Sidebar'
import Burguer from '../navbar/Burguer'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { ProfileService } from '../../services'
import 'react-toastify/dist/ReactToastify.css'

interface IProps {
    children?: React.ReactNode | React.ReactNode[]
    navbar?: boolean
    sidebar?: boolean
    burguer?: boolean
}

/**
 * General component for wrapping pages.
 * @param navbar - Indicates if page will have navbar (Default: true)
 * @param sidebar - Indicates if page will have sidebar (Default: true)
 * @param Burguer - Indicates if page will have navbar mobile(Default: true)
 */
export default function Container({ children, navbar = true, sidebar = true, burguer = true }: IProps): JSX.Element {
    const { setDataUser } = React.useContext(AuthContext) as AuthContextType

    async function init(): Promise<void> {
        const profileContext = await ProfileService.getDataUser()
        setDataUser(profileContext)
    }

    React.useEffect(() => {
        init()
    }, [])

    return (
        <div className="container-wrapper">
            {burguer ? <Burguer /> : null}
            {sidebar ? <Sidebar /> : null}
            <div className="content">
                {navbar ? <Navbar /> : null}
                <div className="page-content">{children}</div>
            </div>
        </div>
    )
}
